/* eslint-disable */
<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        My Reinstatement List
        <v-spacer />
        <v-btn color="primary" @click="openDialog">
          Apply For Student Reinstatement
          <v-icon class="ml-2">mdi-arrow-right</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="reinstatements"
          dense
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
        >
          <template v-slot:[`item.ID`]="{ index }">
            <span>{{ index + 1 }}</span>
          </template>
          <template v-slot:[`item.amountToBill`]="{ item }">
            <span>{{ item.amountToBill | currencyFormat }}</span> </template
          ><template v-slot:[`item.actions`]="{ item }">
            <v-menu open-on-hover>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="text-capitalize links"
                  text
                  v-bind="attrs"
                  v-on="on"
                  small
                  ><v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  :to="{
                    name: 'ReinstatementInvoice',
                    params: { code: item.no },
                  }"
                >
                  <v-icon color="primary">payments</v-icon> Proforma
                </v-list-item>

                <v-divider v-if="item.paid && item.postedReceiptNo" />
                <v-list-item
                  v-if="item.paid && item.recieptNo.length > 0"
                  :to="{
                    name: 'ReinstatementReceipt',
                    params: { code: item.postedReceiptNo },
                  }"
                >
                  <v-icon color="primary">receipt</v-icon> View Receipt
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "ReinstatementList",
  data() {
    return {
      sortBy: "no",
      sortDesc: true,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Reinstatement/getReinstatements");
    });
  },
  computed: {
    headers() {
      return [
        { text: "#S/N", sortable: true, value: "ID", align: "center" },
        { text: "No", value: "no", align: "" },
        { text: "Programme", value: "programme", align: "" },
        { text: "Application Date", value: "documentDate", align: "" },
        { text: "Amount To Bill", value: "amountToBill", align: "" },
        { text: "UnPaid Renewal", value: "unPaidRenewal", align: "" },
        { text: "Actions", value: "actions", align: "" },
      ];
    },
    reinstatements() {
      return this.$store.getters["Reinstatement/reinstatementGetters"](
        "reinstatements",
      );
    },
  },
  methods: {
    openDialog() {
      this.$confirm.show({
        title: "Student Reinstatement",
        text: "Are you sure that you want to apply for a student reinstatement",
        onConfirm: () => {
          this.$store.dispatch("Reinstatement/applyForReinstatement");
        },
      });
    },
  },
};
</script>
